import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';

import { USER_ROLE } from 'constants/logic';
import { Card } from 'components/Card';
import Message from 'components/Message';
import { Title } from 'features/App';
import { dashboardUsersPropTypes } from 'constants/propTypes';
import StaffAccountsCard from './StaffAccountsCardContainer';

const messages = defineMessages({
  title: {
    id: 'staff-accounts.title',
    defaultMessage: 'Staff',
  },
});

const StaffAccounts = ({ owners, managers, frontDesks, isLoading }) => (
  <>
    <Message as={Title} message={messages.title} />
    {isLoading ? (
      <Card loading />
    ) : (
      <>
        <StaffAccountsCard accounts={owners} accountType={USER_ROLE.OWNER} />
        <StaffAccountsCard accounts={managers} accountType={USER_ROLE.MANAGER} />
        <StaffAccountsCard accounts={frontDesks} accountType={USER_ROLE.FRONT_DESK} />
      </>
    )}
  </>
);

StaffAccounts.propTypes = {
  owners: dashboardUsersPropTypes,
  managers: dashboardUsersPropTypes,
  frontDesks: dashboardUsersPropTypes,
  isLoading: PropTypes.bool,
};

export default StaffAccounts;
